import {
  Ban,
  Bell,
  CalendarCheck,
  Clock3,
  DoorOpen,
  GraduationCap,
  HeartPulse,
  type LucideIcon,
  Mail,
  MapPin,
  Plane,
  ShieldAlert,
  Thermometer,
  Ticket,
  UserMinus,
} from 'lucide-react';

/**
 * One icon per category, so a full inbox is scannable before any of it is read. Categories are
 * the API catalogue's, and a category with no entry falls back to the bell rather than breaking
 * the row.
 */
const ICONS: Record<string, LucideIcon> = {
  'allergy-changes': HeartPulse,
  bookings: CalendarCheck,
  'contact-inquiries': Mail,
  'early-dismissals': DoorOpen,
  edp: GraduationCap,
  fever: Thermometer,
  immigration: Plane,
  'it-tickets': Ticket,
  'leave-requests': UserMinus,
  'late-arrivals': Clock3,
  'lesson-excusals': UserMinus,
  'lunch-detentions': ShieldAlert,
  'sst-incidents': ShieldAlert,
  'student-absences': UserMinus,
  suspensions: Ban,
  'tour-requests': MapPin,
};

export function iconForCategory(category: string): LucideIcon {
  return ICONS[category] ?? Bell;
}
